export const DPIA_LIKELIHOOD_OPTIONS = ['unlikely', 'possible', 'likely', 'very_likely'] as const;

export const DPIA_IMPACT_OPTIONS = ['limited', 'significant', 'serious', 'very_serious'] as const;

export const DPIA_RISK_LEVEL_OPTIONS = ['low', 'medium', 'high', 'very_high'] as const;

export const DPIA_MEASURE_STATUS_OPTIONS = ['planned', 'in_progress', 'completed', 'not_applicable'] as const;

export const DPIA_RESIDUAL_RISK_OPTIONS = ['not_assessed', 'low', 'medium', 'high', 'very_high'] as const;

export const DPIA_PRIOR_CONSULTATION_OPTIONS = ['not_assessed', 'not_required', 'may_be_required', 'required'] as const;

export const OWNER_EDITABLE_DPIA_STATUSES = ['draft', 'in_progress', 'clarification_requested'] as const;
